// The fixed room palette, matching services\chat\colors\RoomColor on the server.
// Each key has a dark- and light-theme value in _design_tokens.scss
// (--room-palette-<key>) and a text color to sit on it (--room-palette-<key>-ink).
export const ROOM_PALETTE = ['red', 'orange', 'gold', 'lime', 'green', 'teal', 'cyan', 'blue', 'purple', 'pink', 'white'];

const inPalette = (key) => ROOM_PALETTE.includes(key);

// Inline style that hands a room's colors to its styles as --room-primary,
// --room-primary-ink and --room-secondary. Undefined for a room without colors,
// so the styles' gold defaults apply. A missing secondary uses the primary.
export function roomColorStyle(colors) {
	if (!colors || !inPalette(colors.primary)) return undefined;
	const secondary = inPalette(colors.secondary) ? colors.secondary : colors.primary;
	return {
		'--room-primary': `var(--room-palette-${colors.primary})`,
		'--room-primary-ink': `var(--room-palette-${colors.primary}-ink)`,
		'--room-secondary': `var(--room-palette-${secondary})`,
	};
}
